export default __webpack_public_path__ + "static/media/vi_tejido.e4b15106.mp4";